import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import theme from "../../../theme/Theme";

const TrustSection = () => {
  const navigate = useNavigate();

  return (
    <Box sx={styles.section}>
      <Container maxWidth="lg">
        <Typography sx={styles.sectionTitle}>
          Why Your Audience{" "}
          <span style={styles.titleHighLight}>Will Trust This</span>
        </Typography>
        <Box sx={styles.trustContent}>
          <Typography sx={styles.trustText}>
            Unlike other projects that pay in volatile tokens, we pay in stable
            USDT. Every draw, ticket, and payout is visible on the blockchain.
            Your followers will trust what you promote.
          </Typography>
          <Box
            sx={styles.buttonWrapper}
            role="button"
            onClick={() => navigate("/referrals")}
          >
            <Box sx={styles.buttonContainer}>
              <Typography sx={styles.buttonText}>
                Get Your USDT Referral Link
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const styles = {
  section: {
    padding: { xs: "60px 0", md: "100px 0" },
    position: "relative",
  },
  sectionTitle: {
    fontWeight: "800",
    margin: "0.2em 2em 0.3em 1em",
    fontSize: { xs: "5.5vw", lg: "3.2vw" },
    textAlign: "center",
    color: theme.custom.black,
    textTransform: "uppercase",
    zIndex: 99,
  },
  titleHighLight: {
    color: theme.palette.primary.main,
    borderBottom: "1.5px solid rgba(0, 0, 0, 1)",
  },
  trustContent: {
    textAlign: "center",
    maxWidth: "800px",
    margin: "0 auto",
  },
  trustText: {
    fontSize: "1.2rem",
    marginBottom: "40px",
    fontFamily: '"Proxima Nova", sans-serif',
  },
  connectButton: {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    color: theme.custom.white,
    padding: "16px 40px",
    fontSize: "1.2rem",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
    "&:hover": {
      background: `linear-gradient(to right, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
      transform: "translateY(-2px)",
      boxShadow: "0 6px 25px rgba(0,0,0,0.3)",
    },
    transition: "all 0.3s ease",
  },
  buttonWrapper: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "12px",
    padding: "0.15em",
    width: "fit-content",
    maxWidth: "100%",
    marginTop: { xs: "0.4em", sm: "1em", md: "1.5em" },
    marginBottom: "1em",
    margin: "0 auto",
    transition: "transform 0.2s ease",
    "&:hover": {
      cursor: "pointer",
      transform: "scale(1.02)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  },
  buttonContainer: {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    padding: { xs: "12px 16px", sm: "14px 20px", md: "16px 24px" },
    borderRadius: "10px",
    color: theme.palette.common.white,
    fontSize: { xs: "0.875rem", sm: "1rem" },
    fontWeight: 600,
    textTransform: "uppercase",
    textAlign: "center",
    minHeight: { xs: "40px", sm: "48px" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  },
  buttonText: {
    color: theme.palette.common.white,
    fontSize: "inherit",
    fontWeight: "inherit",
    textTransform: "inherit",
    textAlign: "center",
  },
};

export default TrustSection;
